import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styles from './styles.scss';
import CONFIG from '../../config';
import http from '../../helpers/http';
import img_ico_detial from '../../static/views/ico_detial.png';
import WSpinner from '../../components/WSpinner/WSpinner';
import WMask from '../../components/WMask/WMask';
import WJSON from '../../helpers/json';

class Credit extends Component 
{
  constructor(props){
    super(props);

    this.state = { 
      show_spinner:true,
      message:null,
      point: 0 ,
      addon_point: 0,
      point_list: [],
    };

  }

  componentDidMount(){
    this.pullData()
  }

  pullData(){

    this.setState({ show_spinner: true });

    http.get(CONFIG.API_HOST + 'api/v1.3/points', null, 
    (state, res) => {

        this.setState({ show_spinner: false });

        const {code=100, reason='發生錯誤', data={} } = res;

        if (state === false) { return this.setState({ message: '發生錯誤' }); }

        if (code !== 200)    { return this.setState({ message: reason }); }

        const { points:{point = 0, addon_point = 0 } = {}, point_list = [] } = data;


        this.setState({
          point: point,
          addon_point: addon_point,
          point_list: point_list,
        })
    
    })
  }

  render()
  { 
    
    const items = this.state.point_list.map((item, idx) => 
      <Link to={'/creditview?item='+WJSON.encode(item) }  key={idx} >

        <div className={styles.list_item}>
          <div className={styles.date}>{item.TRANDTIME}</div>
          <div className={styles.title}>
          {item.TRANSTYPE_NAME}{item.POINT}點</div>
          <div className={styles.ico_right}>
            <img src={img_ico_detial} alt="詳細頁"/>
          </div>
        </div>

      </Link>

    );

 
   

    
    return (
      <div className={styles.page_container}>    
        <div className={styles.padding_container}>
          <div className={styles.total_area}>
            <div className={styles.col_6}>
              <div className={styles.title}>免費點數</div>
              <div className={styles.point}>{this.state.point}<span>點</span></div>
            </div>
            <div className={styles.col_6}>
              <div className={styles.title}>儲值點數</div>
              <div className={styles.point}>{this.state.addon_point}<span>點</span></div>
            </div>
          </div>
        </div>
        <div className={styles.padding_container}>
          <div className={styles.small_title}>點數使用紀錄</div>
          {items}
          { this.state.message &&  <WMask title={this.state.message} /> }
          { this.state.show_spinner && <WMask><WSpinner/></WMask> }
        </div>
    
      </div>
    );
  }
}

export default Credit;


// WEBPACK FOOTER //
// ./src/views/Credit/Credit.js